import React, { useState } from "react";
import { useLoader } from "../../utils/LoaderUtils";
import { showError, showSuccess } from "../../utils/toastUtils";
import AuthAPI from "../../api/authApi";
import { handleApiValidationError } from "../../utils/apiErrorHandler";
import SubmitButton from "../../components/partials/global/SubmitButton";

function ChangePassword() {
  const { showLoader, hideLoader } = useLoader();
  const [isLoading, setIsLoading] = useState(false);

  const INITIAL_FORM_DATA = {
    current_password: "",
    new_password: "",
    confirm_password: "",
  };

  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.current_password) {
      newErrors.current_password = "Current password is required.";
    } else if (formData.current_password.length < 6) {
      newErrors.current_password =
        "New password must be at least 6 characters long.";
    }

    if (!formData.new_password) {
      newErrors.new_password = "New password is required.";
    } else if (formData.new_password.length < 6) {
      newErrors.new_password =
        "New password must be at least 6 characters long.";
    }

    if (!formData.confirm_password) {
      newErrors.confirm_password = "Confirm password is required.";
    } else if (formData.confirm_password.length < 6) {
      newErrors.confirm_password =
        "Confirm password must be at least 6 characters long.";
    }

    if (
      formData.new_password &&
      formData.confirm_password &&
      formData.new_password !== formData.confirm_password
    ) {
      newErrors.submitError = "New password and confirm password do not match.";
    }

    if (
      formData.current_password &&
      formData.new_password &&
      formData.current_password === formData.new_password
    ) {
      newErrors.submitError =
        "Current Password & New Password must not be same";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    showLoader();
    setIsLoading(true);
    e.preventDefault();

    if (!validate()) {
      setIsLoading(false);
      hideLoader();
      return;
    }

    try {
      const res = await AuthAPI.updatePassword(formData);
      if (res.code === 200) {
        showSuccess(res.message);
        setFormData(INITIAL_FORM_DATA);

        setTimeout(() => {
          localStorage.removeItem("user");
          window.location.href = "/";
        }, 3000);
      } else {
        showError(res.message);
      }
    } catch (err) {
      handleApiValidationError(err, setErrors);
    } finally {
      setIsLoading(false);
      hideLoader();
    }
  };

  return (
    <>
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>Change Your Password</h4>
            <h6>
              Keep your account secure by updating your password regularly.
            </h6>
          </div>
        </div>
        {/* /product list */}
        <div className="row">
          <div className="col-md-6">
            <div className="card">
              <div className="card-header">
                <h4>Update Your Password</h4>
              </div>
              <div className="card-body profile-body">
                <form method="post" onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-lg-12 col-sm-12">
                      <div className="mb-3">
                        <label className="form-label">
                          Current Password{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="pass-group">
                          <input
                            type={showCurrentPassword ? "text" : "password"}
                            className="form-control"
                            name="current_password"
                            placeholder="Enter Current Password"
                            value={formData.current_password}
                            onChange={handleChange}
                          />
                          <span
                            onClick={() =>
                              setShowCurrentPassword(!showCurrentPassword)
                            }
                            className={`ti toggle-password ${
                              showCurrentPassword ? "ti-eye" : "ti-eye-off"
                            }`}
                          />
                        </div>
                        {errors.current_password && (
                          <span className="errors text-danger">
                            {errors.current_password}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 col-sm-12">
                      <div className="mb-3">
                        <label className="form-label">
                          New Password <span className="text-danger">*</span>
                        </label>
                        <div className="pass-group">
                          <input
                            type={showNewPassword ? "text" : "password"}
                            className="form-control"
                            name="new_password"
                            placeholder="Enter New Password"
                            value={formData.new_password}
                            onChange={handleChange}
                          />
                          <span
                            onClick={() => setShowNewPassword(!showNewPassword)}
                            className={`ti toggle-password ${
                              showNewPassword ? "ti-eye" : "ti-eye-off"
                            }`}
                          />
                        </div>
                        {errors.new_password && (
                          <span className="errors text-danger">
                            {errors.new_password}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 col-sm-12">
                      <div className="mb-3">
                        <label className="form-label">
                          Confirm Password{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="pass-group">
                          <input
                            type={showConfirmPassword ? "text" : "password"}
                            className="form-control"
                            name="confirm_password"
                            placeholder="Enter Confirm Password"
                            value={formData.confirm_password}
                            onChange={handleChange}
                          />
                          <span
                            onClick={() =>
                              setShowConfirmPassword(!showConfirmPassword)
                            }
                            className={`ti toggle-password ${
                              showConfirmPassword ? "ti-eye" : "ti-eye-off"
                            }`}
                          />
                        </div>
                        {errors.confirm_password && (
                          <span className="errors text-danger">
                            {errors.confirm_password}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <SubmitButton
                        isLoading={isLoading}
                        text="Update Password"
                        loadingText="Updating..."
                      ></SubmitButton>
                    </div>
                    {errors.submitError && (
                      <span className="errors text-danger">
                        {errors.submitError}
                      </span>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ChangePassword;
